import React from 'react';
import PropTypes from 'prop-types';
import { formMessageConstants } from '../../utils/constants/form-message-constants';
import { Fragment } from 'react';
import _ from 'lodash';

function RegisterFormBanner(props) {
    return displayBanner(props);
}

const displayBanner = (props) => {

    if (_.isEmpty(props) || _.isEmpty(props.formBanner))
        return "";

    const { bannerTitle, bannerMessage, bannerBackgroundImageSrc,
        displayMessageUnderImage, displayHeadingOverImage, headingColor, textColor } = props.formBanner;

    if (displayMessageUnderImage) {
        return (
            <Fragment>
                <div className='form-popup__bg' style={{ backgroundImage: `url(${bannerBackgroundImageSrc})` }}>
                </div>
                <div className='form-popup__message'>
                    {displayBannerTitle(bannerTitle, headingColor)}
                    {displayBannerMessage(bannerMessage, textColor)}
                </div>
            </Fragment>
        );
    }

    if (displayHeadingOverImage) {
        return (
            <Fragment>
                <div className='form-popup__header form-popup__bg' style={{ backgroundImage: `url(${bannerBackgroundImageSrc})` }}>
                    {displayBannerTitle(bannerTitle, headingColor)}
                </div>
                {displayBannerMessageWithCssClass(bannerMessage, textColor, false)}
            </Fragment>
        );
    }

    return (
        <div className='form-popup__header form-popup__bg' style={{ backgroundImage: `url(${bannerBackgroundImageSrc})` }}>
            {displayBannerTitle(bannerTitle, headingColor)}
            {displayBannerMessage(bannerMessage, textColor)}
        </div>
    );
}

const displayBannerMessageWithCssClass = (bannerMessage, textColor, addMarginTop) => {
    if (_.isEmpty(bannerMessage))
        return null;

    return <div className='form-popup__message'>
        {displayBannerMessage(bannerMessage, textColor, addMarginTop)}
    </div>;
}

const displayBannerMessage = (bannerMessage, textColor, addMarginTop = true) => {
    if (_.isEmpty(bannerMessage)) {
        return "";
    }

    const colorValue = getColor(textColor);

    return <div className={addMarginTop ? 'copy mt-xs' : 'copy'} 
                style={{ color: colorValue }}
                dangerouslySetInnerHTML={{ __html: bannerMessage || formMessageConstants.formBannerMessage }}/>;
}

const displayBannerTitle = (bannerTitle, headingColor) => {
    if (_.isEmpty(bannerTitle))
        return "";

    const colorValue = getColor(headingColor);

    return <h3 className='title' style={{ color: colorValue }}>{bannerTitle || formMessageConstants.formBannerTitle}</h3>;
}

const getColor = (color) => {
    return _.isEmpty(color) ? 'black' : color;
}

RegisterFormBanner.propTypes = {
    formBanner: PropTypes.object.isRequired,
};

export default RegisterFormBanner;
